import React from 'react';
import { Calendar, MapPin, Plane, Hotel, Car, MoreVertical, Clock, CheckCircle, XCircle } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
export function TripsPage() {
  const {
    confirmedTrips
  } = useAppContext();
  const upcomingTrips = [...confirmedTrips.map(trip => ({
    id: trip.id,
    title: trip.title,
    location: trip.location,
    dates: trip.dates,
    status: 'Confirmed',
    statusColor: 'bg-emerald-100 text-emerald-800',
    icon: CheckCircle,
    isNew: true
  })), {
    id: 101,
    title: 'Client Workshop',
    location: 'Chicago, IL',
    dates: 'Nov 18-20',
    status: 'Confirmed',
    statusColor: 'bg-emerald-100 text-emerald-800',
    icon: CheckCircle
  }, {
    id: 102,
    title: 'Tech Conference',
    location: 'Las Vegas, NV',
    dates: 'Dec 02-05',
    status: 'Pending Approval',
    statusColor: 'bg-amber-100 text-amber-800',
    icon: Clock
  }];
  const pastTrips = [{
    id: 4,
    title: 'Q3 Review',
    location: 'New York, NY',
    dates: 'Oct 10-12',
    status: 'Completed',
    statusColor: 'bg-slate-100 text-slate-600'
  }, {
    id: 5,
    title: 'Partner Summit',
    location: 'London, UK',
    dates: 'Sep 24-28',
    status: 'Completed',
    statusColor: 'bg-slate-100 text-slate-600'
  }, {
    id: 6,
    title: 'Sales Kickoff',
    location: 'Miami, FL',
    dates: 'Aug 15-18',
    status: 'Cancelled',
    statusColor: 'bg-red-100 text-red-800'
  }];
  return <div className="space-y-6" data-id="element-1647">
      <div className="flex items-center justify-between" data-id="element-1648">
        <div data-id="element-1649">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-1650">My Trips</h2>
          <p className="text-slate-500" data-id="element-1651">
            Manage your upcoming and past itineraries.
          </p>
        </div>
        <button className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700" data-id="element-1652">
          + Plan New Trip
        </button>
      </div>

      {/* Active Trip Card */}
      <div className="rounded-xl border border-blue-200 bg-blue-50 p-6 shadow-sm" data-id="element-1653">
        <div className="flex items-center justify-between mb-4" data-id="element-1654">
          <span className="rounded-full bg-blue-600 px-3 py-1 text-xs font-medium text-white shadow-sm" data-id="element-1655">
            Current Trip
          </span>
          <button className="text-slate-400 hover:text-slate-600" data-id="element-1656">
            <MoreVertical className="h-5 w-5" data-id="element-1657" />
          </button>
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-1658">
          <div className="flex-1" data-id="element-1659">
            <h3 className="text-xl font-bold text-slate-900" data-id="element-1660">
              Q4 Strategy Meeting
            </h3>
            <div className="mt-2 flex items-center text-slate-600" data-id="element-1661">
              <MapPin className="mr-2 h-4 w-4" data-id="element-1662" />
              San Francisco, CA
            </div>
            <div className="mt-1 flex items-center text-slate-600" data-id="element-1663">
              <Calendar className="mr-2 h-4 w-4" data-id="element-1664" />
              Nov 12 - Nov 15, 2023
            </div>
          </div>
          <div className="flex gap-4" data-id="element-1665">
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-1666">
              <Plane className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-1667" />
              <span className="text-xs font-medium text-slate-600" data-id="element-1668">Flight</span>
            </div>
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-1669">
              <Hotel className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-1670" />
              <span className="text-xs font-medium text-slate-600" data-id="element-1671">Hotel</span>
            </div>
            <div className="rounded-lg bg-white p-4 shadow-sm text-center w-24 border border-blue-100" data-id="element-1672">
              <Car className="mx-auto h-6 w-6 text-blue-600 mb-1" data-id="element-1673" />
              <span className="text-xs font-medium text-slate-600" data-id="element-1674">Car</span>
            </div>
          </div>
        </div>
      </div>

      <h3 className="font-semibold text-slate-800 pt-4" data-id="element-1675">Upcoming Trips</h3>
      <div className="space-y-4" data-id="element-1676">
        {upcomingTrips.map(trip => <div key={trip.id} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm hover:border-blue-300 transition-colors" data-id="element-1677">
            <div className="flex items-start justify-between" data-id="element-1678">
              <div data-id="element-1679">
                <div className="flex items-center gap-2" data-id="element-1680">
                  <h4 className="text-lg font-semibold text-slate-900" data-id="element-1681">
                    {trip.title}
                  </h4>
                  {trip.isNew && <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-1682">
                      NEW
                    </span>}
                </div>
                <div className="flex items-center gap-4 mt-1" data-id="element-1683">
                  <p className="text-slate-500 text-sm flex items-center" data-id="element-1684">
                    <MapPin className="h-3 w-3 mr-1" data-id="element-1685" /> {trip.location}
                  </p>
                  <p className="text-slate-500 text-sm flex items-center" data-id="element-1686">
                    <Calendar className="h-3 w-3 mr-1" data-id="element-1687" /> {trip.dates}
                  </p>
                </div>
              </div>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium flex items-center gap-1 ${trip.statusColor}`} data-id="element-1688">
                {trip.icon && <trip.icon className="h-3 w-3" data-id="element-1689" />}
                {trip.status}
              </span>
            </div>
            <div className="mt-4 flex gap-2 pt-4 border-t border-slate-100" data-id="element-1690">
              <button className="text-sm font-medium text-blue-600 hover:underline" data-id="element-1691">
                View Itinerary
              </button>
              <span className="text-slate-300" data-id="element-1692">|</span>
              <button className="text-sm font-medium text-slate-500 hover:text-slate-700" data-id="element-1693">
                Download Tickets
              </button>
            </div>
          </div>)}
      </div>

      <h3 className="font-semibold text-slate-800 pt-4" data-id="element-1694">Past Trips</h3>
      <div className="space-y-4" data-id="element-1695">
        {pastTrips.map(trip => <div key={trip.id} className="rounded-xl border border-slate-200 bg-slate-50 p-4 opacity-75 hover:opacity-100 transition-opacity" data-id="element-1696">
            <div className="flex items-center justify-between" data-id="element-1697">
              <div data-id="element-1698">
                <h4 className="font-medium text-slate-700" data-id="element-1699">{trip.title}</h4>
                <p className="text-slate-500 text-xs mt-1" data-id="element-1700">
                  {trip.location} • {trip.dates}
                </p>
              </div>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${trip.statusColor}`} data-id="element-1701">
                {trip.status}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}